import { render, staticRenderFns } from "./DepartmentPageHeader.vue?vue&type=template&id=7a8547cf"
import script from "./DepartmentPageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentPageHeader.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports